module.exports = __webpack_public_path__ + "static/media/ic_refresh.5ab70092.svg";